import ReadMachineReportsTab from '../machine_reports/readMachineReports/readMachineReportsTab';
import ReadMachineContractsTab from './readMachineContracts/readMachineContractsTab';
import ReadMachineInvoicesTab from './readMachineInvoice/readMachineInvoicesTab';
import ReadDonneGeneralTab from './readDonneGeneralTab/readDonneGeneralTab';
import ReadMachineNotesTab from '../machine_notes/readMachineNotesTab';
import ReadMachineContentTab from '../../content/readMachineContentTab';
import controlesIcon from '../../../images/controlesSideBarIcon.svg';
import depensesIcon from '../../../images/depensesSideBarIcon.svg';
import { useHasPermission } from '../../../hooks/useHasPermission';
import TabContext from '@mui/lab/TabContext';
import { Badge, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import Iconify from '../../Iconify';
import '../../../css/machines/machineDetailsHeader.css';

const getTabStyles = (tabValue, selectedValue) => ({
    textTransform: 'none',
    color: tabValue === selectedValue ? '#201E1E' : '#6E6D6D',
    fontWeight: '600',
    paddingBottom: 0,
    minHeight: '30px',
    fontFamily: 'Montserrat',
    fontSize: '15px',
    '&.Mui-selected': {
        color: '#201E1E',
    },
});

const MachineDetailsTabs = ({ selectedTab, setSelectedTab }) => {

    const hasReadReportPermission = useHasPermission('controls_view');
    const machineDetailsData = useSelector((state) => state?.MachineDetailsData);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <TabContext value={selectedTab}>
            <Box sx={{ display: 'flex', height: '50px', alignItems: 'center', margin: '20px' }}>
                <TabList
                    variant="scrollable"
                    onChange={handleChange}
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: '#EE792B',
                            height: '2px',
                        },
                    }}
                    sx={{ borderBottom: '1px solid #DEDDDD', width: '100%', justifyContent: 'flex-start' }}
                >
                    <Tab
                        value="1"
                        iconPosition="start"
                        label='Données générales'
                        sx={getTabStyles('1', selectedTab)}
                        icon={<Iconify icon="tdesign:home" sx={{ fontSize: '20px' }} />}
                    />
                    <Tab
                        value="2"
                        iconPosition="start"
                        label="Contrats de maintenance"
                        sx={getTabStyles('2', selectedTab)}
                        icon={<Iconify icon="ion:folder-open-outline" sx={{ fontSize: '20px' }} />}
                    />
                    {hasReadReportPermission &&
                        <Tab
                            value="3"
                            iconPosition="start"
                            label="Rapports de contrôle"
                            sx={getTabStyles('3', selectedTab)}
                            icon={<img src={controlesIcon} alt="icon" width={36} height={36} style={{ marginRight: 0 }} loading='lazy' decoding='async' />}
                        />
                    }
                    <Tab
                        value="4"
                        iconPosition="start"
                        label='Factures'
                        sx={getTabStyles('4', selectedTab)}
                        icon={<img src={depensesIcon} alt="icon" width={36} height={36} style={{ marginRight: 0 }} loading='lazy' decoding='async' />}
                    />
                    <Tab
                        value="5"
                        iconPosition="start"
                        label={
                            <Badge
                                color={
                                    machineDetailsData?.machine_note?.some(note => note.type === 'Securite')
                                        ? 'error'
                                        : machineDetailsData?.machine_note?.some(note => note.type === 'Maintenance')
                                            ? 'warning'
                                            : 'primary'
                                }
                                badgeContent={machineDetailsData?.machine_note?.length}
                            >
                                Remarques
                            </Badge>
                        }
                        sx={getTabStyles('5', selectedTab)}
                        icon={<Iconify icon="simple-line-icons:note" sx={{ fontSize: '20px' }} />}
                    />
                    <Tab
                        value="6"
                        iconPosition="start"
                        label={
                            <Badge color="primary" badgeContent={machineDetailsData?.machine_content?.length}>
                                Contenu pédagogique
                            </Badge>
                        }
                        sx={getTabStyles('6', selectedTab)}
                        icon={<Iconify icon="material-symbols:menu-book-outline" sx={{ fontSize: '20px' }} />}
                    />
                </TabList>
            </Box>

            <TabPanel value="1" sx={{ padding: '0px 20px 0px 20px' }}>
                <ReadDonneGeneralTab />
            </TabPanel>
            <TabPanel value="2" sx={{ padding: '0px 20px 0px 20px' }}>
                <ReadMachineContractsTab />
            </TabPanel>
            {hasReadReportPermission &&
                <TabPanel value="3" sx={{ padding: '0px 20px 0px 20px' }}>
                    <ReadMachineReportsTab />
                </TabPanel>
            }
            <TabPanel value="4" sx={{ padding: '0px 20px 0px 20px' }}>
                <ReadMachineInvoicesTab />
            </TabPanel>
            <TabPanel value="5" sx={{ padding: '0px 20px 0px 20px' }}>
                <ReadMachineNotesTab />
            </TabPanel>
            <TabPanel value="6" sx={{ padding: '0px 20px 0px 20px' }}>
                <ReadMachineContentTab />
            </TabPanel>
        </TabContext>
    );
}

export default MachineDetailsTabs;